import { Component, OnInit } from '@angular/core';

declare function FLFinancialStatementresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;

@Component({
  selector: 'app-side-menuhistory',
  templateUrl: './side-menuhistory.component.html',
  styleUrls: ['./side-menuhistory.component.css']
})
export class SideMenuhistoryComponent implements OnInit {
  route: string;
  pathname = '';
  constructor() { }

  onKeyUp(event: any) {
    debugger;
    if (event.keyCode == 13) {
      if (event.target.id == "financialstatementsID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
        
      }
      if (event.target.id == "AnnualfinancialID") {       
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "BudgetsLink") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "Interimid") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "FailureID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "OtherFinancialID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "DisclosuresID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "RatingID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "UnscheduledID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "BondCallsID") {
        document.getElementById("lblObligar").focus();
        document.getElementById("lblObligar").tabIndex = 32;
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
      }
      
    }
    if (event.keyCode == 9) {
      if (event.target.id == "DocumentCategories") {
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "financialstatementsID") {        
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "AnnualfinancialID") {        
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "BudgetsLink") {        
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "Interimid") {       
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "FailureID") {        
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "OtherFinancialID") {        
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "EventNoticesID") {       
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "DisclosuresID") {       
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      
      if (event.target.id == "RatingID") {        
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "UnscheduledID") {       
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
      if (event.target.id == "BondCallsID") {       
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
    }
  };  

  ngOnInit() {
    debugger;

    // Check for InvestorBrowseFilingTypes and show only those Filing History documents that exist for that obligor.
    //categoryName: "Disclosure Filings"

    var AuditedFinancialStatements = localStorage.ShowAuditedFinancialStatements;
    if (AuditedFinancialStatements == "true") {
      document.getElementById("liShowAuditedFinancialStatements").style.display = "block";
    }
    else {
      document.getElementById("liShowAuditedFinancialStatements").style.display = "none";
    }

    var Annualfinancial = localStorage.ShowAnnualfinancial;
    if (Annualfinancial == "true") {
      document.getElementById("liShowAnnualfinancial").style.display = "block";
    }
    else {
      document.getElementById("liShowAnnualfinancial").style.display = "none";
    }

    var Budgets = localStorage.ShowBudgets;
    if (Budgets == "true") {
      document.getElementById("liShowBudgets").style.display = "block";
    }
    else {
      document.getElementById("liShowBudgets").style.display = "none";
    }

    var Interim = localStorage.ShowInterim;
    if (Interim == "true") {
      document.getElementById("liShowInterim").style.display = "block";
    }
    else {
      document.getElementById("liShowInterim").style.display = "none";
    }

    var Failure = localStorage.ShowFailure;
    if (Failure == "true") {
      document.getElementById("liShowFailure").style.display = "block";
    }
    else {
      document.getElementById("liShowFailure").style.display = "none";
    }

    var OtherFinancial = localStorage.ShowOtherFinancial;
    if (OtherFinancial == "true") {
      document.getElementById("liShowOtherFinancial").style.display = "block";
    }
    else {
      document.getElementById("liShowOtherFinancial").style.display = "none";
    }

    //categoryName : "Event Notices"
    var OtherEvent = localStorage.ShowOtherEvent;
    if (OtherEvent == "true") {
      document.getElementById("liShowOtherEvent").style.display = "block";
    }
    else {
      document.getElementById("liShowOtherEvent").style.display = "none";
    }

    var RatingChange = localStorage.ShowRatingChange;
    if (RatingChange == "true") {
      document.getElementById("liShowRatingChange").style.display = "block";
    }
    else {
      document.getElementById("liShowRatingChange").style.display = "none";
    }

    var Unscheduled = localStorage.ShowUnscheduled;
    if (Unscheduled == "true") {
      document.getElementById("liShowUnscheduled").style.display = "block";
    }
    else {
      document.getElementById("liShowUnscheduled").style.display = "none";
    }

    var BondCalls = localStorage.ShowBondCalls;
    if (BondCalls == "true") {
      document.getElementById("liShowBondCalls").style.display = "block";
    }
    else {
      document.getElementById("liShowBondCalls").style.display = "none";
    }
    
  }
}
